import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { dishes } from "../data/dishes";
import { findKind, eventKinds } from "../data/events";
import { useTheme, useDocumentTitle } from "../hooks/useSite";
import TabStrip from "../components/TabStrip";
import NotFoundPage from "./NotFoundPage";

export default function EventKindPage() {
  const { kind: kindSlug, occasion: occasionSlug } = useParams();
  const kind = findKind(kindSlug);
  const navigate = useNavigate();
  useTheme(dishes[kindSlug === "outdoor" ? 5 : 0]);
  const occasion = kind ? kind.occasions.find((o) => o.slug === occasionSlug) || kind.occasions[0] : null;
  useDocumentTitle(kind ? `${occasion.name} · ${kind.name}` : "Events");
  if (!kind) return <NotFoundPage />;
  const other = eventKinds.find((k) => k.slug !== kind.slug);
  const items = kind.occasions.map((o) => ({ value: o.slug, label: o.name }));

  return (
    <>
      <section className="ro-collection-intro ro-events-kind-intro">
        <div className="ro-container">
          <p className="ro-item-crumb">
            <Link to="/events">Celebrations</Link> / {kind.name}
          </p>
          <h1>
            <strong className="ro-italic">{kind.short}</strong>
            <br />
            <span className="ro-outline">events @RollOver</span>
          </h1>
          <p className="ro-lead ro-events-kind-intro__lead">{kind.intro}</p>
        </div>
      </section>
      <section className="ro-section ro-events-kind">
        <div className="ro-container">
          <TabStrip items={items} value={occasion.slug} label={`${kind.name} occasions`} panelId="ro-occasion-panel" idPrefix="ro-occasion" onSelect={(v) => navigate(`/events/${kind.slug}/${v}`, { state: { preserveScroll: true } })} />
          <article id="ro-occasion-panel" role="tabpanel" aria-labelledby={`ro-occasion-${occasion.slug}`} tabIndex={-1} key={occasion.slug} className="ro-occasion">
            <div className="ro-occasion__media">
              <img src={occasion.image} alt={`${occasion.name} celebration at RollOver`} />
            </div>
            <div className="ro-occasion__body">
              <span className="ro-small">{occasion.name}</span>
              <h2 className="ro-italic">{occasion.headline}</h2>
              {occasion.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
              <Link className="ro-pill ro-pill--solid" to={`/book-event?mode=${encodeURIComponent(kind.mode)}&occasion=${encodeURIComponent(occasion.name)}`}>
                Book a {occasion.name.toLowerCase()}
              </Link>
            </div>
          </article>
          <p className="ro-micro" style={{ marginTop: 40 }}>
            Packages, menus and pricing are agreed with the café when you book. Nothing on this page is a confirmed booking.
          </p>
          <div className="ro-fullmenu__next">
            <Link className="ro-pill" to="/events">
              ← All celebrations
            </Link>
            <Link className="ro-pill" to={`/events/${other.slug}`}>
              {other.name} →
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
